interface SuccessMsgProps {
    message: string;
}

const SuccessMessage: React.FC<SuccessMsgProps> = (
    {
        message,
    }
) => {
    return (
        <p className="o-message-component o-warning-message">
            {message}
        </p>
    )
}

export default SuccessMessage;
